<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-10 py-md-13 py-lg-16 item">
        <div v-if="item.title">
          <TitleWidget class="text-center">{{ item.title }}</TitleWidget>

          <img
            v-if="image"
            class="d-block mt-8 mt-md-10 item-img"
            loading="lazy"
            :src="files + image + '?resize=1&w=960'"
            :alt="item.title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="
              grey--text
              text--darken-2 text-body-1
              mt-8
              ck-content
              item-text
            "
            v-html="item.text"
          ></div>

          <div v-if="images.length" class="mt-12">
            <TitleWidget class="text-center" small>
              Galeria de Fotos
            </TitleWidget>

            <CoolLightBox
              :items="images"
              :index="index"
              @close="index = null"
            />

            <div class="mt-8 images-grid-list">
              <img
                class="d-block cursor-pointer"
                loading="lazy"
                @click="index = keyImages"
                :src="img + '?resize=1&w=300'"
                width="100%"
                v-for="(img, keyImages) in images"
                :key="keyImages"
              />
            </div>
          </div>
        </div>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      return this.item.img &&
        this.item.img.featured &&
        this.item.img.featured.path
        ? this.item.img.featured.path
        : "";
    },
    images() {
      const images = [];
      if (this.item.img && this.item.img.list && this.item.img.list.length)
        this.item.img.list.map(({ path }) => {
          if (path != this.image) images.push(this.files + path);
        });

      return images;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    max-height: 70vh;
    -o-object-fit: contain;
    object-fit: contain;
  }
}

.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
